function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Sent_Homework",
  "data-name": "Sent Homework",
  transform: "translate(-10130.142 -2303.888)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_40",
  "data-name": "Rectangle 40",
  fill: "none",
  stroke: "currentColor",
  "stroke-licecap": "round",
  strokeLinejoin: "round",
  transform: "translate(10138.563 2303.888)"
}, /*#__PURE__*/React.createElement("rect", {
  stroke: "none",
  width: 19.981,
  height: 13.876,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  x: 0.5,
  y: 0.5,
  width: 18.981,
  height: 12.876,
  rx: 1.5
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_123",
  "data-name": "Path 123",
  fill: "none",
  stroke: "currentColor",
  "stroke-licecap": "round",
  d: "M10153.928,2341.657h5.41",
  transform: "translate(-20.702 -33.921)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_124",
  "data-name": "Path 124",
  fill: "none",
  stroke: "currentColor",
  "stroke-licecap": "round",
  d: "M10153.928,2341.657h8.494",
  transform: "translate(-23.786 -30.813)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_125",
  "data-name": "Path 125",
  fill: "none",
  stroke: "currentColor",
  "stroke-licecap": "round",
  d: "M10153.928,2341.657h5.41",
  transform: "translate(-20.702 -27.705)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_127",
  "data-name": "Path 127",
  fill: "none",
  stroke: "currentColor",
  "stroke-licecap": "round",
  strokeLinejoin: "round",
  d: "M10191.54,2303.5l9.083,6.007,8.985-6.007",
  transform: "translate(-52.027 1.851)"
}));

var SvgSentHw = function SvgSentHw(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28.401 13.876",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSentHw, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sent-hw.cf8d7c06.svg";
export { ForwardRef as ReactComponent };